import React, { useEffect, useState } from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

const PDFViewer = (props) => {
    const [fileExists, setFileExists] = useState(true); // Track whether the file exists
    const [loading, setLoading] = useState(true); // Loading state

    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    useEffect(() => {
        const checkFileExists = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}${props.fileUrl}`, {
                    method: "HEAD", // Only fetch headers (no body)
                    cache: "no-cache", // Prevent browser cache issues
                });

                // Check if the file exists (200 status code means the file is available)
                if (response.ok) {
                    setFileExists(true);
                } else {
                    setFileExists(false);
                }
            } catch (error) {
                setFileExists(false);
            } finally {
                setLoading(false); // Done loading (whether file exists or not)
            }
        };

        if (props.fileUrl) {
            checkFileExists();
        }
    }, [props.fileUrl]);

    if (loading) {
        return (
            <div style={{ textAlign: "center", marginTop: "20px" }}>
                <p>Loading...</p>
            </div>
        );
    }

    if (!fileExists) {
        return (
            <div style={{ textAlign: "center", marginTop: "20px" }}>
                <p>The File is not available or could not be found.</p>
            </div>
        );
    }

    return (
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
            <div
                style={{
                    height: "750px",
                    marginLeft: "auto",
                    marginRight: "auto",
                }}
            >
                <Viewer
                    fileUrl={`${process.env.REACT_APP_API_URL}${props.fileUrl}`}
                    plugins={[defaultLayoutPluginInstance]}
                />
            </div>
        </Worker>
    );
};

export default PDFViewer;
